import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchCartList } from "../utils/cart";
import { toast } from 'react-toastify';

const CartProtected = (props) => {
  const [cartData, setCartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasItems, setHasItems] = useState(false);

  console.log('CartProtected: Component mounted with props:', props);

  useEffect(() => {
    const validateCart = async () => {
      try {
        setLoading(true);
        console.log('CartProtected: Starting cart validation...');
        console.log('CartProtected: Auth token check:', {
          localStorage: localStorage.getItem('access_token') ? 'Present' : 'Missing',
          sessionStorage: sessionStorage.getItem('authToken') ? 'Present' : 'Missing'
        });
        const response = await fetchCartList();
        console.log('CartProtected: API response:', response);
        
        // Handle the response structure from fetchCartList
        if (response && response.status === 200 && response.data) {
          console.log('CartProtected: Using response.data (status 200)');
          setCartData(response.data);
          // Check if cart has items
          const hasCartItems = response.data.cart_items && 
                              response.data.cart_items.length > 0;
          console.log('CartProtected: Has cart items:', hasCartItems, 'Count:', response.data.cart_items?.length);
          setHasItems(hasCartItems);
        } else if (response && response.data && response.data.success) {
          console.log('CartProtected: Using response.data (success property)');
          setCartData(response.data);
          const hasCartItems = response.data.cart_items && 
                              response.data.cart_items.length > 0;
          console.log('CartProtected: Has cart items:', hasCartItems, 'Count:', response.data.cart_items?.length);
          setHasItems(hasCartItems);
        } else {
          console.log('CartProtected: Invalid response structure:', response);
          setHasItems(false);
        }
      } catch (error) {
        console.error('CartProtected: Error validating cart:', error);
        setHasItems(false);
      } finally {
        setLoading(false);
      }
    };

    validateCart();
  }, []);

  // Show loading state while validating cart
  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Validating your cart...</p>
            <div className="text-muted mt-2">
              <small>CartProtected Component - Loading State</small>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to cart if no items
  if (!hasItems) {
    console.log('CartProtected: No items in cart, redirecting to /my-cart');
    // Show toast notification
    toast.warning("You need items in your cart to access checkout!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    
    return (
      <>
        {/* Debug info - remove this after fixing */}
        <div className="alert alert-warning m-3" style={{fontSize: '12px'}}>
          <strong>CartProtected Debug:</strong> Redirecting to cart! 
          Items: {cartData?.cart_items?.length || 0}, 
          HasItems: {hasItems ? 'Yes' : 'No'}
        </div>
        <Navigate 
          to={{ 
            pathname: "/my-cart", 
            state: { 
              from: props.location,
              message: "You need items in your cart to access this page."
            } 
          }} 
          replace 
        />
      </>
    );
  }

  console.log('CartProtected: Cart has items, rendering checkout page');

  // Render children if cart has items
  console.log('CartProtected: Final decision - ALLOWING ACCESS (cart has items)');
  return (
    <>
      {/* Debug info - remove this after fixing */}
      <div className="alert alert-info m-3" style={{fontSize: '12px'}}>
        <strong>CartProtected Debug:</strong> Cart validation successful! 
        Items: {cartData?.cart_items?.length || 0}, 
        HasItems: {hasItems ? 'Yes' : 'No'}
      </div>
      {props.children}
    </>
  );
};

export { CartProtected }; 